import { mapState, mapActions, mapMutations } from "vuex";

import Util from '../../util/funcoes';

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('ultimosImoveisVendaStore', {
      imoveis(state) { return state.listaImoveis }
    }),
    util() { return Util }
  },

  methods: {
    ...mapMutations('ultimosImoveisVendaStore', [
      'limparImoveis',
    ]),

    ...mapActions('ultimosImoveisVendaStore', [
      'recuperarUltimosImoveisVenda',
    ]),

    listar() {
      this.showLoading();
      this.limparImoveis();
      this.recuperarUltimosImoveisVenda()
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },
  }
};